// src/services/programaService.js
import api from './api';

const programaService = {
  // Obtener todos los programas
  getProgramas: () => {
    return api.get('/programas');
  },
  
  // Obtener un programa específico por su ID
  getProgramaById: (id) => {
    return api.get(`/programas/${id}`);
  },
  
  // Crear un nuevo programa
  createPrograma: (programaData) => {
    return api.post('/programas', programaData);
  },
  
  // Actualizar un programa existente
  updatePrograma: (id, programaData) => {
    return api.put(`/programas/${id}`, programaData);
  },
  
  // Eliminar un programa
  deletePrograma: (id) => {
    return api.delete(`/programas/${id}`);
  },
  
  // Obtener programas por especialidad
  getProgramasByEspecialidad: (especialidadId) => {
    return api.get(`/programas/especialidad/${especialidadId}`);
  },
  
  // Obtener programas apropiados para la edad de un paciente
  getProgramasByEdad: (edad) => {
    return api.get(`/programas/edad/${edad}`);
  },
  
  // Obtener programas filtrados por especialidad y edad
  getProgramasFiltrados: (especialidadId, edad) => {
    return api.get(`/programas/filtro?especialidad_id=${especialidadId}&edad=${edad}`);
  }
};

export default programaService;